import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass/styled-components';
import DOMPurify from 'isomorphic-dompurify';
import MarkdownRenderer from '../../../components/atoms/MarkdownRenderer';

export const DescriptionRenderer = ({ description, source, organizationName, sx }) => {
  const ref = useRef();

  useEffect(() => {
    const controllers = [];
    if (ref.current) {
      const links = ref.current.querySelectorAll('a');
      links.forEach((link) => {
        const controller = new AbortController();
        controllers.push(controller);
        link.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            window.open(link.href, '_blank');
          },
          {
            signal: controller.signal,
          },
        );
      });
    }

    return () => {
      controllers.forEach((controller) => controller.abort());
    };
  }, []);

  if (source === 'career_page') {
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
      if (['P', 'DIV'].includes(node.nodeName) && node.textContent === '') {
        node.remove();
      }
    });
  }

  return (
    <Box
      mt="40px"
      sx={{
        'li:not(:last-child)': {
          marginBottom: 2,
        },
        'p, span, div, li, ol, ul': {
          color: 'text.main',
          fontSize: '16px!important',
          lineHeight: '140%!important',
          margin: '0 auto 16px',
        },
        'h1, h2, h3, h4, h5, h6': {
          color: 'text.dark',
        },
        'h4, h5, h6': {
          fontSize: '16px',
          margin: '0 auto 16px',
        },
        'h1:not(:first-child)': {
          fontSize: '24px',
          margin: '48px auto 16px',
        },
        'h2:not(:first-child)': {
          fontSize: '20px',
          margin: '32px auto 16px',
        },
        'h3:not(:first-child)': {
          fontSize: '18px',
          margin: '24px auto 16px',
        },
        ul: {
          padding: '0 0 0 32px',
        },
        ...sx,
      }}
    >
      {source === 'career_page' ? (
        <div ref={ref} data-testid="careerPage" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
      ) : (
        <MarkdownRenderer source={description} />
      )}
      {source !== 'career_page' && (
        <Text sx={{ fontStyle: 'italic', mt: '40px', color: 'text.main' }}>
          {organizationName} is an equal opportunity employer.
        </Text>
      )}
    </Box>
  );
};

DescriptionRenderer.defaultProps = {
  sx: {},
};

DescriptionRenderer.propTypes = {
  description: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  organizationName: PropTypes.string.isRequired,
  sx: PropTypes.object,
};
